(module => {
  'use strict';
  QuotedMessageContentCtrl.$inject = ['$scope', '$sce', 'AdNotification', 'UserData'];
  function QuotedMessageContentCtrl($scope, $sce, AdNotification, UserData) {}
  module.controller('QuotedMessageContentCtrl', QuotedMessageContentCtrl);
})(angular.module('postCenterWebClientApp'));
